import { Alert, Box, Collapse, Paper, Stack, Typography } from "@mui/material";
import TitleForm from "../Common/TitleForm";
import Actions from "../Common/Actions";
import { useState } from "react";
import useUpdateChoice from "../Hooks/useUpdateChoice";
import useDeleteChoice from "../Hooks/useDeleteChoice";
import ChoiceForm from "./ChoiceForm";
import Draggable from "../Common/Draggable";
import { Check, Close } from "@mui/icons-material";
import { txt } from "../../../services/translation";

export default function Choice({data}){

    const [titleForm, setTitleForm] = useState(data.edit ? true : false)
    const [form, setForm] = useState(false)

    const [drag, setDrag] = useState(false)

    const updateChoice = useUpdateChoice()
    const deleteChoice = useDeleteChoice()

    const handleNewTitle = title => {
        setTitleForm(false)
        updateChoice({...data, title})
    }

    const handleChange = choice => {
        setForm(false)
        updateChoice(choice)
    }

    return <>

        <Draggable id={data.id} data={{...data, isChoice: true}} disabled={!drag}>

            <Stack sx={{pl: 5}}>

                <Paper
                    variant='outlined'
                    sx={{p: 1}}
                    data-id={data.id}
                    data-rank={data.rank}
                >
                    

                    {titleForm ?
                        <TitleForm
                            title={data.title}
                            onSubmit={handleNewTitle}
                            onCancel={() => setTitleForm(false)}
                        />
                        :
                        <Stack direction='row' alignItems='center' spacing={1}>

                            <Box sx={{flex:1}} onClick={() => setTitleForm(true)}>
                                {data.title ? 
                                    <Stack direction='row' alignItems='center' spacing={1}>
                                        <Typography>{data.letter}. {data.title}</Typography>
                                        {data.correct ? <Check color='info' /> : <Close color='error' />}    
                                    </Stack>
                                    :
                                    <Alert severity='warning'>{txt('addTitle')}</Alert>
                                }
                            </Box>

                            <Actions
                                onDelete={() => deleteChoice(data.id)}
                                onEdit={() => setForm(true)}
                                onDrag={() => setDrag(true)}
                                onDrop={() => setDrag(false)}
                            />
                        </Stack>
                    }

                    <Collapse direction="down" in={form} mountOnEnter unmountOnExit>
                        <ChoiceForm
                            choice={data} 
                            onSubmit={handleChange}
                            onCancel={() => setForm(false)}
                        />
                    </Collapse>

                </Paper>

            </Stack>

        </Draggable>

    </> 
}